import { RefObject, useState } from "react";

import { Box, CircularProgress } from "@mui/material";

import { TLessonDocument } from "../../../../@types";
import { TImageViewerRef } from "../../../common/FileViewer/ImageViewer";

export type TLessonDocumentImageProps = {
	file: TLessonDocument;
	imageViewerRef: RefObject<TImageViewerRef | null>;
};

export function LessonDocumentImage({
	file,
	imageViewerRef,
}: TLessonDocumentImageProps) {
	const [isLoading, setIsLoading] = useState(true);

	const onLoad = () => {
		setIsLoading(false);
	};

	return (
		<div
			className="image-container"
			onClick={() => {
				imageViewerRef.current?.open({ url: file.url });
			}}>
			<img src={file.url} alt={file.name} className="image" onLoad={onLoad} />
			{isLoading && (
				<Box sx={{ position: "absolute", display: "inline-flex" }}>
					<CircularProgress />
				</Box>
			)}
		</div>
	);
}
